import React, { useState } from "react";
import { Menu, MenuItem, MenuItems } from "@headlessui/react";
import clsx from "clsx"; // Import clsx
import { NavLink, useNavigate } from "react-router-dom";

const ProfileDropdown = ({ email, onSignOut }) => {
 

  return (
    <div className="px-4 py-2">
      
      <NavLink
        onClick={onSignOut}
        className="mt-2 block w-full rounded-md bg-gray-900 px-3 py-2 text-sm text-white hover:bg-gray-700"
      >
        Sign Out
      </NavLink>
    </div>
  );
};

const UserMenu = ({ isLoggedIn, email }) => {
  const [isTruncated, setIsTruncated] = useState(true);

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };
  const navigate = useNavigate();

  const handleSignOut = () => {
    navigate("/");
    localStorage.clear();
    window.location.reload();
  };

  return (
    <MenuItems className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
      {isLoggedIn ? (
        <>
          <MenuItem>
            {({ active }) => (
             <p
             className="text-sm text-gray-700 cursor-pointer"
             onClick={toggleTruncate}
           >
             {isTruncated ? `${email.slice(0, 10)}...` : email}
           </p>
            )}
          </MenuItem>
          <MenuItem>
            {({ active }) => (
              <a
                href="#"
                className={clsx(
                  active && "bg-gray-100",
                  "block px-4 py-2 text-sm text-gray-700"
                )}
              >
                Settings
              </a>
            )}
          </MenuItem>
          <MenuItem>
            {() => (
              <ProfileDropdown email={email} onSignOut={handleSignOut} />
            )}
          </MenuItem>
        </>
      ) : (
        <>
          <MenuItem>
            {({ active }) => (
              <a
                href="#"
                className={clsx(
                  active && "bg-gray-100",
                  "block px-4 py-2 text-sm text-gray-700"
                )}
              >
                Login
              </a>
            )}
          </MenuItem>
          <MenuItem>
            {({ active }) => (
              <a
                href="#"
                className={clsx(
                  active && "bg-gray-100",
                  "block px-4 py-2 text-sm text-gray-700"
                )}
              >
                Register
              </a>
            )}
          </MenuItem>
        </>
      )}
    </MenuItems>
  );
};

export default UserMenu;
